<script>
/* COMPOSANTS */
import AkAutocomplete from '@components/general/AkAutocomplete';

/* MIXINS */
import loaderMixin from '@mixins/loaderMixin';
import utilsMixin from '@mixins/utilsMixin';

/* SERVICES */
import accommodationService from '@services/accommodationService';
import {debounce} from '@utils';

export default {
  components: {
    AkAutocomplete,
  },
  mixins: [loaderMixin, utilsMixin],
  props: {
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
    modelValue: {
      type: Number,
      required: false,
    },
    validator: {
      type: Object,
      required: false,
      default: undefined,
    },
    submitted: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    label: {
      type: String,
      required: false,
      default: undefined,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: 'col-md-4 col-6',
    },
    companyId: {
      type: Number,
      required: false,
      default: undefined,
    },
    enabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      items: [],
      debounceFn: undefined,
    };
  },
  mounted() {
    if (this.currentValue !== undefined && this.currentValue !== null) {
      accommodationService.accommodation(this.currentValue).then((d) => {
        this.items.push(d.accommodation);
        this.$refs.autocomplete.init(d.accommodation);
      });
    }
    this.debounceFn = debounce((e) => this.search(e));
  },
  methods: {
    search(event) {
      let search = {};
      search.name = event.query;
      if (this.companyId) search.companyId = this.companyId;
      if (this.enabled !== undefined) search.enabled = this.enabled;
      accommodationService.autocomplete(search).then((data) => {
        this.items = data;
      });
    },
    reset() {
      this.$refs.autocomplete.reset();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <AkAutocomplete
    ref="autocomplete"
    v-model="currentValue"
    :className="className"
    :disabled="disabled"
    :inline="inline"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :submitted="submitted"
    :validator="validator"
    option-label="display"
    option-value="id"
    @search="debounceFn" />
</template>
